module.exports = __webpack_public_path__ + "img/5.144c6739.jpg";